import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="text-center max-w-md mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
        <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400 mb-8">
          הדף לא נמצא
        </p>
        <Button variant="primary" onClick={() => navigate('/')}>
          חזור לדשבורד
        </Button>
      </div>
    </div>
  );
};
export default NotFoundPage;
